import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useAuth } from '@/hooks/useAuth';

interface TopBarProps {
  onMenuClick: () => void;
}

export function TopBar({ onMenuClick }: TopBarProps) {
  const { user } = useAuth();
  const role = user?.role;

  return (
    <header className="md:hidden sticky top-0 z-30 w-full h-14 border-b bg-white flex items-center px-4 gap-3">
      <button
        onClick={onMenuClick}
        className="p-2 rounded-lg hover:bg-gray-100 text-gray-700"
        aria-label="Open menu"
      >
        <Menu className="h-5 w-5" />
      </button>
      <Link to={role === 'admin' ? '/admin' : '/'} className="flex items-center gap-2">
        <img src="/Abby_Logo.png" alt="Abby Connect" className="h-7" />
        <span className="text-sm font-semibold text-gray-900">
          Partner Portal
        </span>
      </Link>
    </header>
  );
}
